export { MacroResults } from './MacroResults'
export type { MacroResultsProps } from './MacroResults'
